/*
 * View for suppression
 */

define([
  "jquery",
  "marionette",
  "modules/topicsSplit/topic/topicExampleModal/suppression/template/suppressionTemplate.html",
], function ($, Marionette, SuppressionTemplate) {
  "use strict";

  const SuppressionView = {};

  SuppressionView.suppressionView = Marionette.ItemView.extend({
    template: SuppressionTemplate,
    events: {
      "change #suppressionLocales": function (e) {
        const languageIds = [];
        $(e.target)
          .children("option:selected")
          .each(function () {
            // jQuery calls this with the selected option as "this"
            const selectedOption = this;
            languageIds.push(+selectedOption.value);
          });
        this.trigger("change:suppressionLocales", languageIds);
      },
      "change #suppressionTouchPoints": function (e) {
        const touchPointIds = [];
        $(e.target)
          .children("option:selected")
          .each(function () {
            // jQuery calls this with the selected option as "this"
            const selectedOption = this;
            touchPointIds.push(+selectedOption.value);
          });
        this.trigger("change:suppressionTouchPoints", touchPointIds);
      },
      "click #suppressedPairDelete": function (e) {
        const id = $(e.target).closest("td").attr("data-id");
        this.trigger("delete:suppressed:pair", id);
      },
      "click #addSuppressionPairs": function () {
        this.trigger("add:pairs:for:suppression");
      },
      "click #deleteAllSuppressionPairs": function () {
        this.trigger("delete:all:suppressed:pairs");
      },
    },
    clearSelection: function () {
      //clear the locale and touchpoint selection
      $("#suppressionLocales").val([]);
      $("#suppressionTouchPoints").val([]);
    },
    modelEvents: {
      sync: "render",
      change: "render",
    },
    triggers: {
      "click #chkSuppress": "toggle:suppress",
      "click #chkOnlyAuthoredLocale": "toggle:onlyAuthoredLocale",
    },
    hideSuppression: function (isHidden) {
      // Hide the check box and label when a locale other than English is selected
      if (isHidden) {
        this.$el.find("#suppressionLabel").hide();
        this.$el.find("#chkSuppress").hide();
      } else {
        this.$el.find("#suppressionLabel").show();
        this.$el.find("#chkSuppress").show();
      }
    },
    getOnlyAuthoredLocale: function () {
      return this.$el.find("#chkOnlyAuthoredLocale").prop("checked");
    },
    getSuppressionStatus: function () {
      return this.$el.find("#chkSuppress")[0].checked;
    },
  });

  return SuppressionView;
});
